var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3726",
  "data-name": "Group 3726",
  transform: "translate(-2364 1058)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_44",
  "data-name": "Ellipse 44",
  transform: "translate(2364 -1058)",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_47",
  "data-name": "Ellipse 47",
  transform: "translate(2371 -1055)",
  fill: "#fff",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1,
  cy: 1,
  r: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2462",
  "data-name": "Rectangle 2462",
  transform: "translate(2371.25 -1052)",
  fill: "#fff",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 1.5,
  height: 6,
  rx: 0.35,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 0.5,
  height: 5,
  rx: 0.15,
  fill: "none"
})))));
export default __webpack_public_path__ + "static/media/tooltipican.ec344de9.svg";
export { SvgComponent as ReactComponent };